import {
  addCard,
  deleteCard,
  getProfile,
  getProfileById,
  updatePassword,
  updateProfile,
  getUpgradePackagesList,
  upgradePackage,
  cancelSubscription,
  getParkingByGroup,
  getAddonsByGroup,
} from "./ProfileActions";
import { createSlice } from "@reduxjs/toolkit";

interface ProfileState {
  profileData: any | null;
  profileLoading: boolean;
  profileError: any | null;

  updateProfileLoading: boolean;
  updateProfileError: any | null;

  updatePasswordLoading: boolean;
  updatePasswordError: any | null;

  addCardLoading: boolean;
  addCardError: any | null;

  profileByIdData: any | null;
  profileByIdLoading: boolean;
  profileByIdError: any | null;

  deleteCardLoading: boolean;
  deleteCardError: any | null;

  getUpgradePackagesListLoading: boolean;
  getUpgradePackagesListError: any | null;
  getUpgradePackagesListData: any | null;

  upgradePackageLoading: boolean;
  upgradePackageError: any | null;
  upgradePackageData: any | null;

  cancelSubscriptionLoading: boolean;
  cancelSubscriptionError: any | null;
  cancelSubscriptionData: any | null;

  getParkingByGroupLoading: boolean;
  getParkingByGroupError: any | null;
  getParkingByGroupData: any | null;

  getAddonsByGroupLoading: boolean;
  getAddonsByGroupError: any | null;
  getAddonsByGroupData: any | null;
}

const initialState: ProfileState = {
  profileData: null,
  profileLoading: false,
  profileError: null,

  updateProfileLoading: false,
  updateProfileError: null,

  updatePasswordLoading: false,
  updatePasswordError: null,

  addCardLoading: false,
  addCardError: null,

  profileByIdData: null,
  profileByIdLoading: false,
  profileByIdError: null,

  deleteCardLoading: false,
  deleteCardError: null,

  getUpgradePackagesListLoading: false,
  getUpgradePackagesListError: null,
  getUpgradePackagesListData: null,

  upgradePackageLoading: false,
  upgradePackageError: null,
  upgradePackageData: null,

  cancelSubscriptionLoading: false,
  cancelSubscriptionError: null,
  cancelSubscriptionData: null,

  getParkingByGroupLoading: false,
  getParkingByGroupError: null,
  getParkingByGroupData: null,

  getAddonsByGroupLoading: false,
  getAddonsByGroupError: null,
  getAddonsByGroupData: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProfile.pending, (state) => {
      state.profileLoading = true;
      state.profileError = null;
      state.profileData = null;
    });
    builder.addCase(getProfile.fulfilled, (state, action) => {
      state.profileData = action.payload;
      state.profileLoading = false;
      state.profileError = null;
    });
    builder.addCase(getProfile.rejected, (state, action) => {
      state.profileError = action.payload;
      state.profileLoading = false;
      state.profileData = null;
    });
    builder.addCase(updateProfile.pending, (state) => {
      state.updateProfileLoading = true;
      state.updateProfileError = null;
    });
    builder.addCase(updateProfile.fulfilled, (state) => {
      state.updateProfileLoading = false;
      state.updateProfileError = null;
    });
    builder.addCase(updateProfile.rejected, (state, action) => {
      state.updateProfileLoading = false;
      state.updateProfileError = action.payload;
    });
    builder.addCase(updatePassword.pending, (state) => {
      state.updatePasswordLoading = true;
      state.updatePasswordError = null;
    });
    builder.addCase(updatePassword.fulfilled, (state) => {
      state.updatePasswordLoading = false;
      state.updatePasswordError = null;
    });
    builder.addCase(updatePassword.rejected, (state, action) => {
      state.updatePasswordLoading = false;
      state.updatePasswordError = action.payload;
    });
    builder.addCase(addCard.pending, (state) => {
      state.addCardLoading = true;
      state.addCardError = null;
    });
    builder.addCase(addCard.fulfilled, (state) => {
      state.addCardLoading = false;
      state.addCardError = null;
    });
    builder.addCase(addCard.rejected, (state, action) => {
      state.addCardLoading = false;
      state.addCardError = action.payload;
    });
    builder.addCase(getProfileById.pending, (state) => {
      state.profileByIdLoading = true;
      state.profileByIdError = null;
      state.profileByIdData = null;
    });
    builder.addCase(getProfileById.fulfilled, (state, action) => {
      state.profileByIdLoading = false;
      state.profileByIdError = null;
      state.profileByIdData = action.payload;
    });
    builder.addCase(getProfileById.rejected, (state, action) => {
      state.profileByIdLoading = false;
      state.profileByIdError = action.payload;
      state.profileByIdData = null;
    });
    builder.addCase(deleteCard.pending, (state) => {
      state.deleteCardLoading = true;
      state.deleteCardError = null;
    });
    builder.addCase(deleteCard.fulfilled, (state) => {
      state.deleteCardLoading = false;
      state.deleteCardError = null;
    });
    builder.addCase(deleteCard.rejected, (state, action) => {
      state.deleteCardLoading = false;
      state.deleteCardError = action.payload;
    });

    builder.addCase(getUpgradePackagesList.pending, (state) => {
      state.getUpgradePackagesListLoading = true;
      state.getUpgradePackagesListError = null;
      state.getUpgradePackagesListData = null;
    });
    builder.addCase(getUpgradePackagesList.fulfilled, (state, action) => {
      state.getUpgradePackagesListLoading = false;
      state.getUpgradePackagesListError = null;
      state.getUpgradePackagesListData = action.payload;
    });
    builder.addCase(getUpgradePackagesList.rejected, (state, action) => {
      state.getUpgradePackagesListLoading = false;
      state.getUpgradePackagesListError = action.payload;
      state.getUpgradePackagesListData = null;
    });

    builder.addCase(upgradePackage.pending, (state) => {
      state.upgradePackageLoading = true;
      state.upgradePackageError = null;
      state.upgradePackageData = null;
    });
    builder.addCase(upgradePackage.fulfilled, (state, action) => {
      state.upgradePackageLoading = false;
      state.upgradePackageError = null;
      state.upgradePackageData = action.payload;
    });
    builder.addCase(upgradePackage.rejected, (state, action) => {
      state.upgradePackageLoading = false;
      state.upgradePackageError = action.payload;
      state.upgradePackageData = null;
    });

    builder.addCase(cancelSubscription.pending, (state) => {
      state.cancelSubscriptionLoading = true;
      state.cancelSubscriptionError = null;
      state.cancelSubscriptionData = null;
    });
    builder.addCase(cancelSubscription.fulfilled, (state, action) => {
      state.cancelSubscriptionLoading = false;
      state.cancelSubscriptionError = null;
      state.cancelSubscriptionData = action.payload;
    });
    builder.addCase(cancelSubscription.rejected, (state, action) => {
      state.cancelSubscriptionLoading = false;
      state.cancelSubscriptionError = action.payload;
      state.cancelSubscriptionData = null;
    });
    builder.addCase(getParkingByGroup.pending, (state) => {
      state.getParkingByGroupLoading = true;
      state.getParkingByGroupError = null;
      state.getParkingByGroupData = null;
    });
    builder.addCase(getParkingByGroup.fulfilled, (state, action) => {
      state.getParkingByGroupLoading = false;
      state.getParkingByGroupError = null;
      state.getParkingByGroupData = action.payload;
    });
    builder.addCase(getParkingByGroup.rejected, (state, action) => {
      state.getParkingByGroupLoading = false;
      state.getParkingByGroupError = action.payload;
      state.getParkingByGroupData = null;
    });
    builder.addCase(getAddonsByGroup.pending, (state) => {
      state.getAddonsByGroupLoading = true;
      state.getAddonsByGroupError = null;
      state.getAddonsByGroupData = null;
    });
    builder.addCase(getAddonsByGroup.fulfilled, (state, action) => {
      state.getAddonsByGroupLoading = false;
      state.getAddonsByGroupError = null;
      state.getAddonsByGroupData = action.payload;
    });
    builder.addCase(getAddonsByGroup.rejected, (state, action) => {
      state.getAddonsByGroupLoading = false;
      state.getAddonsByGroupError = action.payload;
      state.getAddonsByGroupData = null;
    });
  },
});

const profileReducer = profileSlice.reducer;

export default profileReducer;
